import { FC, ReactNode } from 'react'

type Props = {
  children?: ReactNode
  version?: string
  contentClassName?: string
}

const PageContainer: FC<Props> = ({ children, version, contentClassName }) => {
  return (
    <div
      className={
        contentClassName ||
        'h-[100dvh] w-full flex flex-col justify-between flex-1 relative pt-[env(safe-area-inset-top)]'
      }
    >
      {children}
      <div className='absolute right-1 bottom-0 text-gray-400 text-[8px] z-20 drop-shadow-md'>
        {version && <span>{version}</span>}
      </div>
    </div>
  )
}

export default PageContainer
